var module = angular.module('octopusApp.configuration');

module.controller('BackupEditController', function($scope, $location, busy, octopusRepository, unsavedChanges) {
  var isLoading = $scope.isLoading = busy.create();
  var isSaving = $scope.isSaving = busy.create();

});






//////////////////
// WEBPACK FOOTER
// ./app/areas/configuration/backup/controllers/backup_edit_controller.js
// module id = 898716513565890
// module chunks = 1